import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import MobileHeader from '../../components/mobile/MobileHeader';
import styles from './MobileNotFoundPage.module.css';

/**
 * Mobile 404 Not Found Page
 * 手機版找不到頁面提示，2 秒後自動導向首頁
 */
const MobileNotFoundPage = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(2);
  const navigateRequested = useRef(false);

  useEffect(() => {
    // Prevent navigation if already requested
    if (navigateRequested.current) return;

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigateRequested.current = true;
          // Schedule navigation after the current render cycle
          setTimeout(() => navigate('/'), 0);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className={styles.notFoundPage}>
      <MobileHeader title="找不到頁面" showBack={false} />
      <div className={styles.content}>
        <div className={styles.icon}>🔍</div>
        <h1 className={styles.code}>404</h1>
        <p className={styles.message}>找不到您要的頁面</p>
        <p className={styles.countdown}>
          將在 <span className={styles.countdownNumber}>{countdown}</span> 秒後自動返回首頁...
        </p>
        <button
          className={styles.homeButton}
          onClick={() => navigate('/')}
        >
          立即返回首頁
        </button>
      </div>
    </div>
  );
};

export default MobileNotFoundPage;
